<template>
  <b-row>
    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group
        :label="$t('user.accountNumber')"
        label-for="user-accountNumber"
      >
        <b-form-input
          id="user-accountNumber"
          v-model="accountNumber"
          @keypress="isNumber($event)"
           dir="ltr"
         type="number"
        />
      </b-form-group>
    </b-col>

    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group :label="$t('user.iBAN')" label-for="user-iBAN">
        <b-form-input id="user-iban" v-model="iBAN"  dir="ltr"
         type="number" />
      </b-form-group>
    </b-col>
    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group :label="$t('user.bankId')" label-for="user-bankName">
        <my-v-select
            :key="bankId"
          id="user-bankName"
          v-if="banks"
          :translate="false"
          v-model="bankId"
          :concat-label="['title']"
          :options="banks.length ? banks : []"
          :multiple="false"
          :searchable="true"
          :filterable="true"
        />
        <!--        <b-form-select-->
        <!--            id="user-bankName"-->
        <!--            v-model="bankId"-->
        <!--            :options="banks"-->
        <!--            text-field="title"-->
        <!--            value-field="_id"-->
        <!--        />-->
      </b-form-group>
    </b-col>
    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group
        :label="$t('user.accountType')"
        label-for="user-accountType"
      >
        <b-form-input
          id="user-accountType"
          v-model="accountType"
          text-field="title"
          value-field="_id"
        />
      </b-form-group>
    </b-col>
    <b-col lg="3" md="4" sm="6" xl="2">
      <b-form-group
        :label="$t('user.cooperationType')"
        label-for="user-companyType"
      >
        <my-v-select
            :key="cooperationType"
          id="user-CompanyType"
          v-if="companyTypes"
          :translate="false"
          v-model="cooperationType"
          :concat-label="['text']"
          :reduce-field="['value']"
          :options="companyTypes.length ? companyTypes : []"
          :multiple="false"
          :searchable="true"
          :filterable="true"
        />
        <!--        <b-form-select-->
        <!--            id="user-CompanyType"-->
        <!--            v-model="cooperationType"-->
        <!--            :options="companyTypes"-->
        <!--            text-field="text"-->
        <!--            value-field="value"-->
        <!--        />-->
      </b-form-group>
    </b-col>
    <b-col lg="7" md="10" sm="12" xl="10">
      <b-form-group
        :label="$t('user.description')"
        label-for="user-description"
      >
        <b-form-input
          id="user-description"
          v-model="description"
          text-field="title"
          value-field="_id"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import onlyEnglish from "@/mixins/onlyEnglish";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
export default {
  props: ["v"],
  mixins: [onlyEnglish],
  components: {
    MyVSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormInvalidFeedback,
  },
  computed: {
    ...mapGetters({
      banks: "banks/banks",
      companyTypes: "user/companyTypes",
    }),
    accountNumber: {
      set(accountNumber) {
        this.$store.commit("user/SET_ACCOUNT_NUMBER", accountNumber);
      },
      get() {
        return this.$store.getters["user/accountNumber"];
      },
    },
    iBAN: {
      set(iBAN) {
        this.$store.commit("user/SET_IBAN", iBAN);
      },
      get() {
        return this.$store.getters["user/iBAN"];
      },
    },
    bankId: {
      set(bankId) {
        this.$store.commit("user/SET_BANK_ID", bankId);
      },
      get() {
        return this.$store.getters["user/bankId"];
      },
    },
    accountType: {
      set(accountType) {
        this.$store.commit("user/SET_ACCOUNT_TYPE", accountType);
      },
      get() {
        return this.$store.getters["user/accountType"];
      },
    },
    cooperationType: {
      set(cooperationType) {
        this.$store.commit("user/SET_COOPERATION_TYPE", cooperationType);
      },
      get() {
        return this.$store.getters["user/cooperationType"];
      },
    },
    description: {
      set(description) {
        this.$store.commit("user/SET_DESCRIPTION", description);
      },
      get() {
        return this.$store.getters["user/description"];
      },
    },
    // invalidFeedbackAccountNumber: {
    //   set(error) {
    //   },
    //   get() {
    //     var error = "";
    //     if (!this.v.accountNumber.$dirty) return error;
    //     if (!this.v.accountNumber.required) error = "required";
    //     return error;
    //   },
    // },
    // invalidFeedbackIban: {
    //   set(error) {
    //   },
    //   get() {
    //     var error = "";
    //     if (!this.v.iBAN.$dirty) return error;
    //     if (!this.v.iBAN.required) error = "required";
    //     return error;
    //   },
    // },
    // invalidFeedbackBankName: {
    //   set(error) {
    //   },
    //   get() {
    //     var error = "";
    //     if (!this.v.bankId.$dirty) return error;
    //     if (!this.v.bankId.required) error = "required";
    //     return error;
    //   },
    // },
    // invalidFeedbackAccountType: {
    //   set(error) {
    //   },
    //   get() {
    //     var error = "";
    //     if (!this.v.accountType.$dirty) return error;
    //     if (!this.v.accountType.required) error = "required";
    //     return error;
    //   },
    // },
    // invalidFeedbackCompanyType: {
    //   set(error) {
    //   },
    //   get() {
    //     var error = "";
    //     if (!this.v.cooperationType.$dirty) return error;
    //     if (!this.v.cooperationType.required) error = "required";
    //     return error;
    //   },
    // },
  },
};
</script>
